import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const heartHealthFeatures: LandingPageFeature[] = [
  {
    id: 'cardiovascular_age',
    title: 'heart_health_features_cva_heading',
    description: 'heart_health_features_cva_copy',
    image: {
      format: 'png',
      localizedAlt: 'cardio_age_app_ui_alt',
      localizedSrc: 'heart_health_cardio_age_app_ui',
    },
  },
  {
    id: 'cardiovascular_capacity',
    title: 'heart_health_features_cardio_heading',
    description: 'heart_health_features_cardio_copy',
    image: {
      format: 'png',
      localizedAlt: 'cardio_cap_app_ui_alt',
      localizedSrc: 'heart_health_cardio_capacity_app_ui',
    },
  },
  {
    id: 'heart_rate',
    title: 'pdp_heart_rate',
    description: 'heart_health_features_heart_rate_copy',
    image: {
      format: 'png',
      localizedAlt: 'heart_rate_app_ui_alt',
      localizedSrc: 'heart_health_heart_rate_app_ui',
    },
  },
  {
    id: 'heart_rate_variability',
    title: 'meet_oura_ring_HRV',
    description: 'heart_health_features_hrv_copy',
    image: {
      format: 'png',
      localizedAlt: 'hrv_app_ui_alt',
      localizedSrc: 'heart_health_hrv_app_ui',
    },
  },
];

export default heartHealthFeatures;
